import { convertListToText } from '../common/Util';
import { ActivityDTO } from '@behavior/activity/dto/ActivityDTO';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';
import { ChemicalProductDTO } from '@behavior/inventories/dto/ChemicalProductDTO';
import ReportFlex from '../common/ReportFlex';
import ReportAccordion from '../common/ReportAccordion';
import ReportForm from '../common/ReportForm';
import { ActivityContactTable } from './ActivityContactTable';
import { ActivityChemicalProductTable } from './ActivityChemicalProductTable';
import { View } from '@react-pdf/renderer';
import styles from '../common/styles';

export const ActivityReportAccordian = ({ activity }: { activity: ActivityDTO }) => {
  const locationText = convertListToText(
    activity.location?.map(location => location.location.locationInfo) || []
  );

  const tableCellWidth = 150;

  const contactTable = {
    header: ['Name', 'Email', 'Phone'],
    data: ['name', 'email', 'telephone1'] as Array<keyof PersonDTO>,
  };

  const chemicalProductTable = {
    header: ['Trade Name', 'Chemical Name', 'State'],
    data: ['tradeName', 'chemicalName', 'state.name'] as Array<keyof ChemicalProductDTO>,
  };
  return (
    <ReportAccordion header="activity.details.page.activity.details.container.title">
      <View style={[styles.thinRoundBorder]}>
        <ReportForm
          labels={[
            'activity.report.page.components.activity.title',
            'activity.report.page.components.activity.description',
            'activity.report.page.components.activity.department',
            'activity.report.page.components.activity.locations',
          ]}
          values={[activity.title, activity.description, activity.department, locationText]}
        />
      </View>
      <ActivityContactTable
        contactTable={contactTable}
        contacts={activity.contacts}
        width={tableCellWidth}
      />
      <ActivityChemicalProductTable
        chemicalProducts={activity.chemicalProducts}
        chemicalProductTable={chemicalProductTable}
        width={tableCellWidth}
      />
    </ReportAccordion>
  );
};
